import { jsx as _jsx } from "react/jsx-runtime";
export const NotFoundPage = () => {
    return _jsx("div", { style: { width: '100%', height: '100%', backgroundColor: 'black', color: 'white' }, children: "404: Path not found" });
};
//# sourceMappingURL=NotFoundPage.js.map